import {sanitizeLanguageFileJSON} from "~/langutils/sanitizeLanguageFile";

export async function loadLanguageJSON(sprachkuerzel:string) {
    const response = await $fetch(`/konfigurator_html/languageFiles/texts-${sprachkuerzel}.json`);
    return sanitizeLanguageFileJSON(response);
}
